import React from "react";

function WorkCard({ position, title, text, img }) {
  return (
    <>
      <div
        className="work-card-text"
        style={position % 2 === 0 ? { order: 2 } : { order: 1 }}
      >
        <h2>{title}</h2>
        <p>{text}</p>
        <a href="#" className={position % 2 === 0 ? "align-button-right" : ""}>
          Learn More
        </a>
      </div>
      <img
        src={img}
        alt="frame"
        className="work-cad-img"
        style={position % 2 === 0 ? { order: 1 } : { order: 2 }}
      />
    </>
  );
}

export default WorkCard;
